import css from '@styled-system/css';
import { ThemeStyles } from '@honda-canada/design-system-react';

const themeStyles = new ThemeStyles();

themeStyles.addBaseStyles('ColorSwatch')(
  css({
    display: 'flex',
    flexFlow: 'column',
    alignItems: 'center',
    width: '80px',
  }),
);

themeStyles.addBaseStyles('UpChargePrice')(
  css({
    fontFamily: 'bold',
    textAlign: 'center',
    mt: 'xxs',
    position: 'relative',
    '& > span': {
      position: 'absolute',
    },
  }),
);

export default themeStyles;
